<script>
    import app from "../stores/app";
    import R, {LOADER} from "../lib/requests";
    import Alert from "../stores/alerts";
    import Notifier from "../stores/notifier";
    import {createEventDispatcher} from 'svelte/internal';
    import {copyObjectData} from "../lib/lib";
    import AppIcon from "../components/icons/AppIcon.svelte";
    import UserEditModal from "../users/UserEditModal.svelte";

    export let transporter = null;

    let userId = null;
    let userDriver = null;

    const dispatch = createEventDispatcher();

    const onCreate = () => {
        app.editDriver(0, transporter.id, closeEdit);
    }

    const onEdit = (driver) => {
        // dispatch('edit', hotel.id);
        app.editDriver(driver.id, transporter.id, closeEdit);
    }

    const closeEdit = (driver) => {
        app.clearDriver();
        if (driver) {
            let d = transporter.drivers.find(x => x.id == driver.id);
            if (!d) {
                transporter.drivers = [driver, ...transporter.drivers];
            } else {
                copyObjectData(driver, d, true);
                transporter.drivers = transporter.drivers;
            }
        }
    }

    const onDelete = (obj) => {
        Alert.delete("Delete driver", `This will permanently delete driver "${obj.name}".\nAre you sure?`, () => deleteDriver(obj.id));
    }

    const deleteDriver = (id) => {
        const onSuccess = result => {
            transporter.drivers = transporter.drivers.filter(x => x.id !== result);
            Notifier.showMessage("Driver deleted");
        }

        const onFailure = err => {
            if (err.code === 'object_related') {
                let message = [];

                Object.keys(err.params).map(key => {
                    if (err.params[key] > 0) {
                        message.push(`${err.params[key]} ${key}`);
                    }
                });

                Alert.warning("Delete driver", `Driver is associated with ${message.join(", ")}.\nYou can not delete this driver.`);
            }
        };

        R.handle(R.driver.delete, id, onSuccess, onFailure, LOADER.POPUP);
    }

    const onEditUser = (obj) => {
        userDriver = obj;
        userId = obj.user_id;
    }


    const onCreateUser = (obj) => {
        userDriver = obj;
        userId = 0;
        console.log("onCreateUser", obj);
    }

    const closeUser = (obj) => {
        console.log("closeUser", obj);
        if (obj) {
            let item = transporter.drivers.find(x => x.id == userDriver.id);
            if (item) {
                item.user_id = obj.driver_id ? obj.id : null;
                transporter.drivers = transporter.drivers;
            }
        }
        userDriver = null;
        userId = null;
    }
</script>

<div class="panel panel-default mb-5">
    <div class="panel-heading py-2">
        Drivers
        <button class="btn btn-primary btn-sm py-1" on:click="{ onCreate }" disabled="{ transporter.id == 0 }">
            CREATE DRIVER
        </button>
    </div>
    {#if transporter.id > 0}
        {#if transporter.drivers.length}
            <table class="table table-list">
                <tbody>
                {#each transporter.drivers as item}
                    <tr class="row-hover">
                        <td>
                            <span class="is-link" class:not-active={ item.is_active < 1 }
                                  on:click="{ () => onEdit(item) }">
                                { item.name }
                            </span>
                        </td>
                        {#if item.user_id > 0}
                            <td class="button-column pointer" title="open related user"
                                on:click="{ () => onEditUser(item) }">
                                <AppIcon icon="user-solid" size="16"/>
                            </td>
                        {:else}
                            <td class="button-column text-light pointer" title="create user for driver"
                                on:click="{ () => onCreateUser(item) }">
                                <AppIcon icon="user-solid" size="16"/>
                            </td>
                        {/if}

                        <td class="button-column pointer" title="delete driver" on:click="{ () => onDelete(item) }">
                            <AppIcon icon="trash" size="16"/>
                        </td>
                    </tr>
                {/each}
                </tbody>
            </table>
        {:else}
            <div class="panel-body panel-pad">
                Transporter has no drivers.
            </div>
        {/if}
    {:else}
        <div class="panel-body panel-pad">
            Save new transport company in order to add drivers.
        </div>
    {/if}
</div>
{#if userId != null}
    <UserEditModal {userId} driver={userDriver} closeCallback="{ closeUser }"/>
{/if}